export class CalcResponseModel {

  public napomena: string;
  public datumPocetka: string;
  public napomenaLekarski: string;
  public napomenaInfo: string;
  public premija: number;
  public trajanje: number;
  public brojRata: number;
  public osiguranasuma: number;
  public osiguranasumaUTZ: number;
  public tarifa: string;
  public tarifaId: number;
  public pol: string;
  public starost: number;
  public kapital: number;
  public otkupIGodina: number;
  public renta: number;
  public rentaPara: number;
  public uiOs: number;
  public uiBolDan: number;
  public uiPremija: number;
  public auzPremija: number;
  public rdzPremija: number;
  public brutoPremija: number;
  public rataPara: number;
  public osrdz: number;
  public trajanjeRDZ: number;
  public prvaRata: number;
  public lekarski: string;
  public posMesec: number;
  public posStarost: number;
  public posTrajanje: number;
  public posUi: number;
  public posPol: number;
  public posVrsta: number;
  public posBrojRata: number;
  public posIndex: boolean;
  public posAUZ: boolean;
  public brojPonude: number;
  public nepobitnost: number;
  public sledecarata: number;

  public ukupnaRenta: number;
  public zagarantovanaRenta: number;
  public bonusRenta: number;
  public pol2: number;
  public starost2: number;
  public opisTarife: string;

  public hiOs: number;
  public hiPremija: number;

  public vrednostiPoGodini: Vrednosti[];

  public userId: number;
}
/*
export class R3List {
  public year: number;
  public mathRueckkaufswerte: string;
  public otkupnaVrednostPlusDobitSrednjaVrednost: string;
  public ablebensLeistungen: string;
  public osiguranaSumaPlusDobitPesimisticnaVrednost: string;
  public osiguranaSumaPlusDobitSrednjaVrednost: string;
  public osiguranaSumaPlusDobitOptimisticnaVrednost: string;
  public reduktionswerte: string;
}
*/
export class Vrednosti {
  public godina: number;
  public otkup: number;
  public kapitalizacija: number;
  public dobit: number;
}



// WEBPACK FOOTER //
// ./src/app/models/calc-response.model.ts